/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Space,
  Popconfirm,
  message,
  Modal,
  Tag,
  Checkbox,
  Spin,
  Row,
  Col,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import { notificationTopicApi } from "../../api/NotificationApi";
import { serialNum, capitaliseWithHyphen } from "../../utils";
import urls from "../../api/urls";
import API from "../../api";

const { GET_USERS_MASTER_LIST } = urls;

const TopicList = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState(0);
  const [users, setUsers] = useState([]);
  const [isModalOpenUsers, setIsModalOpenUsers] = useState(false);
  const [modalUsers, setModalUsers] = useState([]);
  const [selectedTopicId, setSelectedTopicId] = useState(null);
  const [filter, setFilter] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [selectedUserValues, setSelectedUserValues] = useState([]);
  const [filterByRole, setFilterByRole] = useState(false);
  const pageUserSize = 10000;
  const roleMap = {
    ROLE_HOADMIN: "HO Admin",
    ROLE_CPADMIN: "CP Admin",
    ROLE_CPOPERATOR: "CP Operator",
    ROLE_CPDRIVER: "CP Driver",
    ROLE_HOOPERATOR: "HO Operator",
    ROLE_HOMARKETING: "HO Marketing",
    ROLE_CPBOOKINGONLY: "CP Booking Only",
    ROLE_CLIENTADMIN: "Client Admin",
  };

  function getFormattedRole(roleKey) {
    return roleMap[roleKey] || roleKey;
  }

  useEffect(() => {
    getNotificationTopic();
    getUsers(`?pageNum=${0}&pageSize=${pageUserSize}`);
  }, []);

  useEffect(() => {
    let filterVal = "";
    if (filter?.length > 0) {
      filterVal = `&filter=${filter}`;
    }
    const timeout = setTimeout(() => {
      getUsers(`?pageNum=0&pageSize=10000&search=${searchText}${filterVal}`);
    }, 300);

    return () => clearTimeout(timeout);
  }, [searchText]);
  const getNotificationTopic = async () => {
    setLoading(true);
    const response = await notificationTopicApi.getNotificationTopic();

    if (response?.status) {
      setTableData(response?.response?.data?.data || []);
      setTotalPageSize(response?.response?.data?.count || 0);
      setLoading(false);
    } else {
      message.error(
        response?.response?.data?.message || "Internal Server Error"
      );
      setLoading(false);
    }
  };

  const getUsers = async (page) => {
    setDrawerLoading(true);
    const response = await API.Api(
      GET_USERS_MASTER_LIST + page
    ).getWithUserNPremiseHeader();
    if (response?.status) {
      setDrawerLoading(false);
      setUsers(
        response?.response?.data?.userListResponse?.map((item) => ({
          value: item?.userId?.toString(),
          searchText: `${item?.firstName} ${item?.lasName || ""} ${
            item?.mobileNum || ""
          } ${getFormattedRole(item?.roleAs) || ""} ${
            item?.premiseName || ""
          }`.toLowerCase(),
          label: (
            <span style={{ fontSize: "11px" }}>
              <span style={{ fontWeight: 500, fontSize: "13px" }}>
                {item?.firstName} {item?.lastName || ""}
              </span>{" "}
              {/* {item?.mobileNum && `(${item?.mobileNum})`}{" "} */}
              {item?.roleAs && (
                <Tag color="blue" style={{ fontSize: "9px", padding: "0px" }}>
                  {getFormattedRole(item?.roleAs)}
                </Tag>
              )}
              {item?.assignUser?.toUpperCase() === "CP" &&
                item?.premiseName &&
                `(${item?.premiseName})`}
            </span>
          ),
        }))
      );
    } else {
      setDrawerLoading(false);
      message.error(
        response?.response?.data?.message || "Internal Server Error"
      );
    }
  };
  const handleDelete = async (id) => {
    const response = await notificationTopicApi.deleteNotificationTopic(id);
    if (response?.status) {
      message.success(response?.response?.data?.message);
      getNotificationTopic();
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const showModalUsers = async (id) => {
    const response = await notificationTopicApi.getNotificationTopicDetails(id);
    if (response?.status) {
      const subscribers = response?.response?.data?.subscribersNames || [];
      setModalUsers(subscribers);
      setIsModalOpenUsers(true);
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const handleModalCloseUsers = () => {
    setIsModalOpenUsers(false);
    setModalUsers([]);
  };
  const columns = [
    {
      title: "SI",
      dataIndex: "sl",
      width: "5%",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Topic Name",
      dataIndex: "name",
      key: "name",
      width: "10%",
      render: (data) => capitaliseWithHyphen(data) || "-",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "40%",
    },
    {
      title: "Subscribe Users",
      dataIndex: "subscribersCount",
      key: "subscribersCount",
      width: "5%",
      render: (users, record) => {
        if (!users || users.length === 0) return null;

        return (
          <>
            {/* <Tag color="blue">{firstUser}</Tag> */}
            {users > 0 && (
              <Button
                type="link"
                onClick={() => showModalUsers(record?.id)}
                style={{
                  padding: "0",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  background: "#16A34A",
                  color: "#fff",
                  fontSize: "12px",
                }}
              >
                {users}
              </Button>
            )}
          </>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (data) => data || "-",
      width: "10%",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) =>
        !record?.isSystemGenerated && (
          <Space>
            <Button
              type="text"
              icon={<EditOutlined style={{ color: "#2e69fc" }} />}
              onClick={() => handleEdit(record)}
            />
            <Popconfirm
              title="Are you sure you want to delete this topic?"
              onConfirm={() => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined style={{ color: "#2e69fc" }} />}
              />
            </Popconfirm>
          </Space>
        ),
    },
  ];

  const handleCreateTopic = () => {
    setIsDrawerOpen(true);
  };

  const handleEdit = async (record) => {
    setDrawerLoading(true);
    const response = await notificationTopicApi.getNotificationTopicDetails(
      record.id
    );
    if (response?.status) {
      let data = response?.response?.data;

      setDrawerLoading(false);
      setSelectedTopicId(record.id);

      form.setFieldsValue({
        name: data?.name,
        description: data?.description,
        subscribers: data?.subscribers,
      });
      setIsDrawerOpen(true);
    } else {
      message.error(response?.response?.data?.message);
      setDrawerLoading(false);
    }
  };

  const onClose = () => {
    form.resetFields();
    setIsDrawerOpen(false);
    setFilter([]);
    setSelectedUserValues([]);
  };

  const onSubmit = async (values) => {
    let response;
    if (selectedTopicId) {
      response = await notificationTopicApi.putNotificationTopic(
        selectedTopicId,
        values
      );
    } else {
      response = await notificationTopicApi.postNotificationTopic(values);
    }
    if (response?.status) {
      message.success(response?.response?.data?.message);
      onClose();
      getNotificationTopic();
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const handleTableChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const handleUserChange = (values) => {
    if (values.includes("select_all")) {
      const allValues = users.map((user) => user.value);
      setSelectedUserValues(allValues);
      form.setFieldsValue({
        subscribers: allValues,
      });
    } else if (values.includes("diselect_all")) {
      setSelectedUserValues([]);
      form.setFieldsValue({
        subscribers: [],
      });
    } else {
      //setSelectedUserValues(values);
      form.setFieldsValue({
        subscribers: values,
      });
    }
  };
  const customOptions = [];
  if (users?.length > 0) {
    customOptions.push({
      label: <b>Select All</b>,
      value: "select_all",
    });

    if (selectedUserValues?.length > 0) {
      customOptions.push({
        label: <b>Deselect All</b>,
        value: "diselect_all",
      });
    }

    customOptions.push(...users);
  }

  return (
    <div>
      <div className="flex-end">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleCreateTopic}
          style={{ marginTop: "-10px" }}
          className="save-btn"
        >
          Create Topic
        </Button>
      </div>
      <Table
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        className="mt-1 wallet-table"
        columns={columns}
        //defaultCurrent={1}
        onChange={handleTableChange}
        dataSource={tableData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalPageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          showSizeChanger: true,
          itemRender: itemRender,
        }}
      />
      <Drawer
        title={selectedTopicId ? "Edit Topic" : "Create Topic"}
        placement="right"
        onClose={onClose}
        open={isDrawerOpen}
        width={720}
      >
        <Spin spinning={drawerLoading}>
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Form.Item
              name="name"
              label="Topic Name"
              rules={[{ required: true, message: "Please enter topic name" }]}
            >
              <Input placeholder="Enter topic name" />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
              rules={[{ required: true, message: "Please enter description" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter description" />
            </Form.Item>
            <Col span={24}>
              <Checkbox
                checked={filterByRole}
                onChange={(e) => setFilterByRole(e.target.checked)}
              >
                <p className="mt-1">
                  <FilterOutlined /> Filter recipients by Role
                </p>
              </Checkbox>
            </Col>
            {filterByRole && (
              <Checkbox.Group
                value={filter}
                onChange={(value) => {
                  setFilter(value);
                  let filterVal;
                  if (value.length > 0) {
                    filterVal = `&filter=${value}`;
                  }
                  getUsers(
                    `?pageNum=${0}&pageSize=${pageUserSize}${filterVal || ""}`
                  );
                }}
              >
                <Row>
                  {Object.keys(roleMap).map((role) => (
                    <Col span={6} key={role}>
                      <Checkbox value={role}>{roleMap[role]}</Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}

            <Form.Item
              className="mt-1"
              name="subscribers"
              label={`Subscribe Users (${selectedUserValues?.length})`}
              rules={[{ required: true, message: "Please select users" }]}
            >
              <Select
                onChange={handleUserChange}
                mode="multiple"
                placeholder="Select users"
                options={customOptions}
                style={{ width: "100%" }}
                showSearch
                onSearch={(value) => {
                  setSearchText(value);
                }}
                filterOption={(input, option) =>
                  option?.searchText
                    ?.toLowerCase()
                    ?.includes(input.toLowerCase())
                }
              />
            </Form.Item>
            <div className="flex-end mt-2">
              <Button onClick={onClose} className="mr-1">
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" className="save-btn">
                Submit
              </Button>
            </div>
          </Form>
        </Spin>
      </Drawer>
      <Modal
        title="Subscribed Users"
        open={isModalOpenUsers}
        onCancel={handleModalCloseUsers}
        footer={null}
        width={700}
      >
        <Space wrap>
          {modalUsers?.map((user, index) => (
            <Tag key={index} color="geekblue">
              {user}
            </Tag>
          ))}
        </Space>
      </Modal>
    </div>
  );
};

export default TopicList;
